module.exports = __webpack_public_path__ + "static/media/logo-footer.d895b68c.svg";